import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { theme } from "@theme";
import LPressable from "@components/LPressable";
import Decagon from "@components/Activity/Decagon";
import LArtwork from "@components/LArtwork";
import SkeletonPlaceholder from "react-native-skeleton-placeholder";
import {
  LOADING_SHIMMER_SPEED,
  LOADING_SHIMMER_BG_COLOR,
  LOADING_SHIMMER_HIGHLIGHT_COLOR,
} from "../../config";
import { getActiveTab } from "@hooks/useActiveTab";
import { AccessDetailsDismiss } from "../../types";

type ArtistProps = {
  artistName: string;
  artistImage: string | null;
  dismiss: AccessDetailsDismiss;
  artistId: string;
};

const Artist = ({
  artistName,
  artistImage,
  artistId,
  dismiss,
}: ArtistProps) => {
  return (
    <LPressable
      sentryEventName="AccessDetail.Artist"
      onPress={() => {
        dismiss({
          pathname: `/(app)/(tabs)/${getActiveTab()}/artist/[artistId]`,
          params: {
            artistId,
          },
        });
      }}
    >
      <LBox flexDirection="row" alignItems="center" gap="s1">
        {artistImage ? (
          <Decagon size={17} showBackground={false}>
            <LArtwork url={artistImage} imageSize="small" size={17} />
          </Decagon>
        ) : null}
        <LText variant="Body/B2/Medium" color="lightGrey">
          {artistName}
        </LText>
        <LIcon
          colors={{ color: theme.colors.lightGrey }}
          name="chevron"
          rotate={270}
          size={8}
        />
      </LBox>
    </LPressable>
  );
};

const Loading = () => {
  return (
    <SkeletonPlaceholder
      highlightColor={LOADING_SHIMMER_HIGHLIGHT_COLOR}
      backgroundColor={LOADING_SHIMMER_BG_COLOR}
      speed={LOADING_SHIMMER_SPEED}
      borderRadius={theme.borderRadii.m}
    >
      <LBox flexDirection="row" alignItems="center" gap="s1">
        <SkeletonPlaceholder.Item
          width={150}
          height={17}
          borderRadius={theme.borderRadii.m}
        />
      </LBox>
    </SkeletonPlaceholder>
  );
};

export default {
  Artist,
  Loading,
};
